
import Alert from 'vux/src/components/alert/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Group from 'vux/src/components/group/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import value2name from 'vux/src/filters/value2name.js'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'


export default {
components: {
Group,
XInput,
XHeader,
XButton,
Toast,
Selector,
Grid,
GridItem,
GroupTitle,
Cell,
Alert,
XAddress,
XSwitch
},
name: "expertInfo",
data() {
return {
name: "",
idcard: "",
mobile: "",
ename: "",
emobile: "",
etelephone: "",
zipcode: "",
eduList: [
{key: 1, value: "博士研究生"},
{key: 2, value: "硕士研究生"},
{key: 3, value: "本科"},
{key: 4, value: "专科"},
{key: 5, value: "其他"}
],
addressData: ChinaAddressV4Data,
showAddress: false,
address1: [],
address2: "",
result: "",
isVisible: false,
isShow: false,
strInfo: "",
company: '',
isReadonly: true
};
},
methods: {
save() {
if (this.ename === '') {
alert('紧急联系人不能为空')
return
}
if (this.emobile === '') {
alert('紧急联系人手机不能为空')
return
}
if (this.address1.length !== 3 && !this.address2) {
alert('地址不能为空')
return
}
if (this.company === '') {
alert('请填写就职公司')
return
}
let address = value2name(this.address1, ChinaAddressV4Data);
address = address.split(' ')
var obj = {
name: this.name,
idcard: this.idcard,
mobile: this.mobile,
ename: this.ename,
emobile: this.emobile,
etelephone: this.etelephone,
province: address[0],
city: address[1],
district: address[2],
daddress: this.address2,
zipcode: this.zipcode,
company: this.company,
sequence: 0
};
var opid = localStorage.getItem("userid");
var head = {
headers: {
token: localStorage.getItem("token"),
opid: opid
}
};
let that = this;
this.$http
.post("/api/v1/experts/" + opid, obj, head)
.then(function (res) {
let visible = that.isVisible ? "yes" : "no";
that.$http.put("/api/v1/experts/" + opid + "/visible", {visible: visible}, head)
.then(function (res) {
that.$router.push({name: "vip"});
})
.catch(function (error) {
that.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
});
});
})
.catch(function (error) {
that.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
});
})
},
updateVisible() {
this.isShow = true;
if (this.isVisible) {
this.strInfo = "已设置可见";
} else {
this.strInfo = "已设置不可见";
}
}
},
created() {
var opid = localStorage.getItem("userid");
var obj = {
headers: {
token: localStorage.getItem("token"),
opid: opid
}
};
this.$http.get("/api/v1/users/" + opid, obj)
.then((res) => {
this.name = res.data.detail.name;
this.idcard = res.data.detail.idcard;
this.mobile = res.data.detail.mobile;
this.company = res.data.detail.company;
this.address1 = [res.data.detail.province, res.data.detail.city, res.data.detail.district]
this.address2 = res.data.detail.daddress
if (!res.data.detail.idcard) {
this.isReadonly = false
}
})
.catch((error) => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: "cancel",
time: "1000"
});
});
}
};



// WEBPACK FOOTER //
// ./src/components/addexpertInfo.vue